export const typography = {
  fontFamily: 'Inter',
  h1: {
    fontSize: '36px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '26px',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#071B3A',
  },
  h3: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h5: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  subtitle1: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
    color: 'rgba(7, 27, 58, 0.8)',
  },
  body2: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  button: {
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
};
